import { connect } from 'react-redux';
import LaporanJP from '../../views/Settings/LaporanJP.view';
import {
  getParamOptionsAcademics, getClassesOptions, getPeriodsOptions, getPrmLevels, getSchoolUnitsOptions, getParamPerwakilan,
} from '../../states/thunks/options.thunk';
import {
  reportSchedule, studentCount, reportSchPerunit, reportSchPerwakilan,
} from '../../states/thunks/academics.thunk';


function mapStateToProps(state) {
  return {
    classes: state.options.classes,
    levels: state.options.levels,
    user: state.user || {},

  };
}

function mapDispatchToProps(dispatch) {
  return {
    handleStudentCount: payload => dispatch(studentCount(payload)),
    getClassesOptions: payload => dispatch(getClassesOptions(payload)),
    getParamOptionsAcademics: (payload, type) => dispatch(getParamOptionsAcademics(payload, type)),
    handleReportSchedule: (payload, goback) => dispatch(reportSchedule(payload, goback)),
    handleReportSchPerunit: (payload, goback) => dispatch(reportSchPerunit(payload, goback)),
    handleReportSchPerwakilan: (payload, goback) => dispatch(reportSchPerwakilan(payload, goback)),
    getPeriodsOptions: payload => dispatch(getPeriodsOptions(payload)),
    getPrmLevels: payload => dispatch(getPrmLevels(payload)),
    getSchoolUnitsOptions: payload => dispatch(getSchoolUnitsOptions(payload)),
    getParamPerwakilan: payload => dispatch(getParamPerwakilan(payload)),

  };
}

export default connect(mapStateToProps, mapDispatchToProps)(LaporanJP);
